<template>
    <section class="mb-4">
        <div class="grid grid-cols-1 sm:grid-cols-2">
            <div class="flex flex-col gap-4 justify-center text-black">
                <div>
                    <h1 class="text-4xl font-bold mb-2 xl:text-6xl">
                        Browse without a trace
                    </h1>
                    <p>
                        Without a virtual private network connection, your IP address
                        is exposed throughout all activities that take place online.
                        This could leave you and your network vulnerable to attacks,
                        reveals your location, and identifies the source of the traffic (you).
                    </p>
                </div>
                <div>
                    <h1 class="text-4xl font-bold mb-2 xl:text-6xl">
                        Safeguard your privacy
                    </h1>
                    <p>
                        When using a virtual private network, your internet traffic
                        is routed through our encrypted tunnels, masking your IP address,
                        keeping your confidential data safe, and securing your internet connection
                        without sacrificing network speeds.
                    </p>
                </div>
            </div>
            <div>
                <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024" version="1.1"><path class="st0" d="M512,128c-212.1,0-384,171.9-384,384s171.9,384,384,384c26,0,51.3-2.6,75.8-7.5c-9.9-4.7-11-40.2-1.2-60.4c10.9-22.5,45-79.5,11.2-98.6s-24.4-27.8-45-49.9s-12.2-25.5-13.5-31.1c-4.5-19.5,19.9-48.8,21-51.8s1.1-14.2,0.8-17.6s-15.4-12.4-19.1-12.8s-5.6,6-10.9,6.4s-28.1-13.9-33-17.6s-7.1-12.8-13.9-19.5s-7.5-1.5-18-5.6s-44.2-16.5-70.1-27s-28.1-25.2-28.5-35.6s-15.8-25.5-23-36.4c-7.2-10.9-8.5-25.9-11.2-22.5s13.5,42.8,10.9,43.9s-8.2-10.9-15.8-20.6s7.9-4.5-16.1-51.8s7.5-71.3,9-96s20.2,9,10.5-6.8s0.8-48.8-6.8-60.8S275,230,275,230c1.1-11.6,37.5-31.5,63.8-49.9s42.3-4.1,63.4,2.6s22.5,4.5,15.4-2.2s3-10.1,19.5-7.5s21,22.5,46.1,20.6s2.6,4.9,6,11.2s-3.8,5.6-20.2,16.9s0.4,11.2,29.6,32.6s20.2-14.2,17.2-30s21.4-3.4,21.4-3.4c18,12,14.7,0.7,27.8,4.8s48.7,34.2,48.7,34.2c-44.6,24.4-16.5,27-9,32.6s-15.4,16.5-15.4,16.5c-9.4-9.4-10.9,0.4-16.9,3.8s-0.4,12-0.4,12c-31,4.9-24,37.5-23.6,45.4s-19.9,19.9-25.1,31.1s13.5,35.6,3.8,37.1s-19.5-36.8-72-22.5c-15.8,4.3-51,22.5-32.2,59.6s49.9-10.5,60.4-5.2s-3,28.9-0.8,29.2s29.6,1,31.1,33s41.6,29.2,50.2,30s37.5-23.6,41.6-24.8s20.6-15,56.6,5.6s54.4,17.6,66.8,26.2s3.8,25.9,15.4,31.5s58.1-1.9,69.8,17.2s-48,115.1-66.8,125.6S719.8,778.6,701,794s-45,34.4-69.8,49.1c-21.9,13-25.8,36.4-35.6,43.7C767.5,848.7,896,695.3,896,512C896,299.9,724.1,128,512,128z M602,488.4c-5.2,1.5-16.1,11.2-42.8-4.5s-45-12.8-47.2-15.4c0,0-2.2-6.4,9.4-7.5c23.9-2.3,54,22.1,60.8,22.5s10.1-6.8,22.1-2.9C616.2,484.5,607.2,486.9,602,488.4z M476.4,166.2c-2.6-1.9,2.2-4.1,5-7.9c1.6-2.2,0.4-5.8,2.5-7.9c5.6-5.6,33.4-13.5,27.9,1.9C506.4,167.8,480.5,169.2,476.4,166.2z M543.5,215c-9.4-0.4-31.4-2.7-27.4-6.8c15.8-15.8-6-20.2-19.5-21.4s-19.1-8.6-12.4-9.4s33.8,0.4,38.2,4.1s28.9,13.5,30.4,20.6S552.9,215.4,543.5,215z M624.9,212.4c-7.5,6-45.2-21.5-52.5-27.8c-31.5-27-48.4-18-55-22.5c-6.6-4.5-4.3-10.5,5.9-19.5s38.6,3,55.1,4.9s35.6,14.6,36,29.8C614.8,192.4,632.4,206.4,624.9,212.4z" fill="#171717"/></svg>
                    <div class="absolute top-1/4 right-0">
                        <app-segment extraStyleClass="border-l-2 border-asoc-white">
                            <template v-if="location.city">
                                <h1 class="text-3xl font-bold">👋🏼 We see you!</h1>
                                <span class="flex items-center flex-row pl-2 text-xl">
                                    <img draggable="false" class="mr-2" :src="`https://flagcdn.com/20x15/${location.countryCode.toLowerCase()}.png`">
                                    {{ location.city }}, {{ location.regionName }}
                                </span>
                            </template>
                            <h1 class="text-3xl font-bold" v-else>🌎 Searching the world...</h1>
                        </app-segment>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import AppSegment from '@/components/AppSegment.vue';

export default {
    components: {
        AppSegment,
    },
    data() {
        return {
            location: {},
        };
    },
    mounted() {
        if (process.env.NODE_ENV !== 'production') { return; }
        const location = JSON.parse(localStorage.getItem('homeLocation'));
        if (!location || location.expire < Date.now()) {
            this.axios.get('/users/location')
                .then((e) => {
                    this.location = e.data;
                    localStorage.setItem('homeLocation', JSON.stringify({ expire: Date.now() + 600000, data: e.data }));
                });
        } else {
            this.location = location.data;
        }
    },
};
</script>
